export const common = {
  // Header
  "header.solutions": "Solutions",
  "header.about": "À propos", 
  "header.testimonials": "Témoignages",
  "header.contact": "Contact",
  "header.getStarted": "Commencer",
  
  // Hero Section
  "hero.slide1.title": "Optimisez les Opérations avec l'IA Intelligente",
  "hero.slide1.subtitle": "Optimisez vos processus industriels avec des agents IA de pointe, améliorant l'efficacité et la productivité à travers les États-Unis.",
  "hero.slide2.title": "Excellence Industrielle Alimentée par l'IA", 
  "hero.slide2.subtitle": "Transformez vos processus de fabrication avec l'automatisation intelligente et l'analyse prédictive.",
  "hero.slide3.title": "Solutions Numériques Intelligentes",
  "hero.slide3.subtitle": "Exploitez la puissance de l'IA agentique pour des systèmes d'automatisation avancés et des opérations industrielles intelligentes.",
  "hero.optimizeWithAI": "Optimiser avec l'IA",
  "hero.learnMore": "En savoir plus",
  
  // About Section
  "about.title": "Autonomiser les Industries avec l'Innovation IA",
  "about.paragraph1": "Chez AiCH, nous sommes à l'avant-garde de la transformation des paysages industriels grâce à des agents IA avancés. Basés aux États-Unis, notre mission est d'améliorer l'efficacité opérationnelle et l'innovation dans divers secteurs.",
  "about.paragraph2": "Nos solutions de pointe s'intègrent parfaitement aux systèmes existants, stimulant la croissance et la durabilité. Rejoignez-nous pour façonner l'avenir de l'industrie avec intelligence et ingéniosité.",
  
  // Values Section
  "values.badge": "Amélioration de l'Industrie",
  "values.title": "Innovation IA pour la Croissance Industrielle",
  "values.subtitle": "Autonomiser les industries avec des solutions IA de pointe qui stimulent le progrès, améliorent l'efficacité et favorisent une croissance durable à travers les États-Unis.",
  "values.innovation.title": "Innovation",
  "values.innovation.description": "Chez AiCH, nous nous engageons à repousser les limites de la technologie. Notre équipe explore continuellement de nouvelles frontières en IA pour livrer des solutions de pointe qui autonomisent les industries.",
  "values.integrity.title": "Intégrité",
  "values.integrity.description": "Nous croyons en la conduite de nos affaires avec le plus haut niveau d'honnêteté et de transparence. Nos clients nous font confiance pour fournir des solutions IA fiables et éthiques qui stimulent le succès.",
  "values.collaboration.title": "Collaboration",
  "values.collaboration.description": "Le travail d'équipe est au cœur de tout ce que nous faisons. Nous favorisons un environnement collaboratif où les idées diverses prospèrent, menant à des solutions créatives et au succès partagé.",
  "values.excellence.title": "Excellence",
  "values.excellence.description": "Notre poursuite de l'excellence nous pousse à livrer des produits et services supérieurs. Nous nous dédions à atteindre les plus hauts standards dans tout ce que nous faisons, assurant qualité et valeur pour nos clients.",
  "values.sustainability.title": "Durabilité",
  "values.sustainability.description": "AiCH s'engage dans des pratiques durables qui bénéficient à la fois à nos clients et à la planète. Nous nous efforçons de créer des solutions IA qui sont non seulement efficaces mais aussi responsables environnementalement.",
  
  // Solutions Section
  "solutions.badge": "Efficacité Libérée",
  "solutions.title": "Optimisez l'Efficacité avec l'IA Avancée",
  "solutions.subtitle": "Améliorez la productivité avec des solutions IA de pointe adaptées aux applications industrielles, stimulant une croissance sans précédent et l'excellence opérationnelle.",
  "solutions.predictiveMaintenance.title": "Maintenance Prédictive",
  "solutions.predictiveMaintenance.description": "Utilisez l'IA pour anticiper les pannes d'équipement et réduire les temps d'arrêt.",
  "solutions.processOptimization.title": "Optimisation des Processus",
  "solutions.processOptimization.description": "Améliorez l'efficacité opérationnelle grâce aux insights pilotés par l'IA.",
  "solutions.qualityControl.title": "Automatisation du Contrôle Qualité", 
  "solutions.qualityControl.description": "Implémentez l'IA pour assurer une qualité de produit cohérente et réduire les défauts.",
  "solutions.supplyChain.title": "Efficacité de la Chaîne d'Approvisionnement",
  "solutions.supplyChain.description": "Optimisez la logistique et la gestion des stocks avec l'analyse IA.",
  "solutions.energyManagement.title": "Gestion de l'Énergie",
  "solutions.energyManagement.description": "Réduisez la consommation d'énergie en utilisant l'IA pour surveiller et ajuster l'usage.",
  "solutions.safetyMonitoring.title": "Surveillance de Sécurité",
  "solutions.safetyMonitoring.description": "Améliorez la sécurité au travail avec surveillance et alertes alimentées par l'IA.",
  
  // Testimonials Section
  "testimonials.badge": "Impact Prouvé",
  "testimonials.title": "Écoutez Nos Partenaires", 
  "testimonials.subtitle": "Les solutions IA innovantes d'AiCH ont transformé nos opérations, augmentant l'efficacité et stimulant une croissance sans précédent. Hautement recommandé !",
  "testimonials.jordan.content": "AiCH a révolutionné nos opérations avec ses solutions IA de pointe. L'efficacité et la productivité ont monté en flèche, nous permettant de nous concentrer sur la croissance stratégique.",
  "testimonials.alex.content": "Les agents IA d'AiCH ont transformé l'efficacité et l'innovation de notre flux de travail. Leur expertise en IA industrielle est inégalée, nous offrant des insights stratégiques et une croissance durable.",
  "testimonials.taylor.content": "Le partenariat avec AiCH a été transformateur pour nous. Leurs solutions pilotées par l'IA ont rationalisé nos processus, augmentant à la fois l'efficacité et l'innovation. C'est un changement de donne pour toute industrie.",
  
  // CTA Section
  "cta.title": "Transformez Votre Industrie Aujourd'hui",
  "cta.subtitle": "Débloquez une efficacité et une innovation sans précédent avec les solutions IA avancées d'AiCH adaptées aux leaders industriels. Élevez vos opérations et gardez une longueur d'avance sur le marché concurrentiel.",
  "cta.exploreSolutions": "Explorer les Solutions",
  "cta.scheduleDemo": "Planifier une Démo",
  
  // Language Switcher
  "language.select": "Langue"
};

export default {
  ...common,
  cta: {
    title: 'Prêt à Transformer Votre Industrie ?',
    subtitle: 'Rejoignez les entreprises leaders qui exploitent l\'IA pour stimuler l\'innovation et l\'efficacité. Discutons de la façon dont nos solutions peuvent bénéficier à votre entreprise.',
    exploreSolutions: 'Explorer les Solutions',
    scheduleDemo: 'Planifier une Démo'
  },
  demo: {
    title: 'Planifier une Démonstration',
    subtitle: 'Remplissez le formulaire ci-dessous et notre équipe vous contactera sous peu pour organiser une démonstration personnalisée.',
    name: 'Nom Complet',
    namePlaceholder: 'Entrez votre nom complet',
    email: 'Adresse Email',
    emailPlaceholder: 'Entrez votre email',
    company: 'Nom de l\'Entreprise',
    companyPlaceholder: 'Entrez le nom de votre entreprise',
    phone: 'Numéro de Téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    message: 'Informations Supplémentaires',
    messagePlaceholder: 'Parlez-nous de vos besoins et intérêts...',
    submit: 'Soumettre la Demande',
    submitting: 'Envoi en cours...',
    cancel: 'Annuler',
    successMessage: 'Merci ! Votre demande de démonstration a été soumise avec succès. Nous vous contacterons bientôt.',
    errorMessage: 'Désolé, une erreur s\'est produite lors de la soumission de votre demande. Veuillez réessayer.'
  }
};
